import React, { useState } from 'react';
import { bool, func } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import raiseError from '../../utils/raiseError';

import './style.scss';

const ShowMore = ({ hasMorePages = false, loadMore = noop }) => {
    const [loading, setLoading] = useState(false);

    const onLoadMoreClick = async () => {
        setLoading(true);
        await handleLoadMore();
        setLoading(false);
    };

    const handleLoadMore = async () => {
        try {
            await loadMore();
        } catch (error) {
            raiseError();
        }
    };

    if (!hasMorePages) {
        return null;
    }

    return (
        <div className="show-more">
            <Button onClick={onLoadMoreClick} loading={loading} fill={Button.FILLS.GHOST}>
                <I18n k="collections_perseus.general.show_more" />
            </Button>
        </div>
    );
};

ShowMore.propTypes = {
    hasMorePages: bool,
    loadMore: func,
};

export default ShowMore;
